export const filterSpecificationOptions = {
  ignoredTransmissions: ['TRANSMISSION_SEMI_AUTOMATIC'],
  ignoredDrives: ['DRIVE_FRONT', 'DRIVE_REAR'],
  allowedDoorCount: ['DOORCOUNT_1', 'DOORCOUNT_2_3', 'DOORCOUNT_4_5', 'DOORCOUNT_6_7'],
};
